import { ActionType, RootAction } from '@/actions/actiontypes';
import { UserState } from '@/state';

const initialState: UserState = new UserState();

export const userReducer = (state: UserState = initialState, action: RootAction) => {
    switch (action.type) {
        case ActionType.BOOTSTRAP:
            return action.bootstrappedState.userState;
        case ActionType.LOGIN:
            return UserState.fromIdToken(action.idToken);
        case ActionType.LOGIN_FAILED:
            return state.override({ loginError: action.errorMessage });
        case ActionType.LOGOUT:
            return new UserState();
        default:
            return state;
    }
};
